import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
export var reduxModuleLoaded = createAction(reduxKey + ".REDUX_MODULE_LOADED", function () { return ({}); });
export var requestTiers = createAction(reduxKey + ".REQUEST_TIERS", function () { return ({}); });
export var requestTiersSuccess = createAction(reduxKey + ".REQUEST_TIERS_SUCCESS", function (tiers) { return ({ tiers: tiers }); });
export var requestTiersFailure = createAction(reduxKey + ".REQUEST_TIERS_FAILURE", function (error) { return ({ error: error }); });
export var subscribeToTier = createAction(reduxKey + ".SUBSCRIBE_TO_TIER", function (tier) { return ({ tier: tier }); });
//# sourceMappingURL=actions.js.map